<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToGrid'
});
</script>
<template>
	<div ref="el" class="to-grid" :flex="flex ? flex : null" :class="setClass" :style="setStyle">
		<slot></slot>
	</div>
</template>

<script setup lang="ts">
import { computed, provide, ref } from 'vue'
import type { CSSProperties } from 'vue'


type GridProps = {
	flex?: boolean
	type?: string
	mode?: string
	dir?: string
	gap?: number | string
	padding?: number | string
	paddingPosition?: string
	height?: number | string
	verticalAlign?: string
	va?: string
	col?: number | string
	wrap?: boolean
}

const el = ref(null)

// 默认值
const props = withDefaults(defineProps<GridProps>(), {
	flex: false,
	type: '',
	mode: 'default',
	dir: '',
	gap: 0,
	padding: 0,
	paddingPosition: '',
	height: '',
	verticalAlign: '',
	va: '',
	col: '',
	wrap: true
})

provide('grid', props)

const hasUnit = (val: string) => /[a-z%]+$/i.test(val)
const setStyle = computed((): CSSProperties => {
	const styles: CSSProperties = {}

	if (props.padding && String(props.padding).trim()) {
		// 分割成各个值
		const padded = String(props.padding)
			.trim()
			.split(/\s+/)
			.map(val => {
				// 如果是数字（或纯数字字符串），或末尾无单位，就加 em
				return hasUnit(val) ? val : `${val}em`
			})
			.join(' ')

		styles.padding = padded
	}

	if (props.padding && props.paddingPosition !== '') {
		if (!props.paddingPosition.includes('t')) {
			styles.paddingTop = 0
		}
		if (!props.paddingPosition.includes('r')) {
			styles.paddingRight = 0
		}
		if (!props.paddingPosition.includes('b')) {
			styles.paddingBottom = 0
		}
		if (!props.paddingPosition.includes('l')) {
			styles.paddingLeft = 0
		}
	}

	if (props.height && props.height !== 'full') {
		if (!isNaN(Number(props.height))) {
			styles.height = props.height + 'em'
		}
	}

	if (props.col && props.col !== 'col-auto') {
		styles['--col'] = props.col
	}

	if (props.gap) {
		const gaps = String(props.gap).split(' ')
		styles['--gap-y'] = gaps[0] + 'em'
		styles['--gap-x'] = gaps.length > 1 ? gaps[1] + 'em' : gaps[0] + 'em'
	}

	return styles
})

const setClass = computed(() => {
	const classes: string[] = []

	if (props.mode) classes.push(`mode-${props.mode}`)
	if (props.type) classes.push(`type-${props.type}`)
	if (props.dir) classes.push(`dir-${props.dir}`)
	if (props.col && props.col !== 'auto') classes.push(`is-col`)
	if (props.col) classes.push(`col-${props.col}`)
	if (props.height === 'full') classes.push(`height-full`)
	if (props.verticalAlign === 'top' || props.va === 'top') classes.push('va-top')
	if (props.verticalAlign === 'bottom' || props.va === 'bottom') classes.push('va-bottom')
	if (props.verticalAlign === 'baseline' || props.va === 'baseline') classes.push('va-baseline')
	if (props.verticalAlign === 'full' || props.va === 'full' || props.verticalAlign === 'stretch' || props.va === 'stretch') classes.push('va-full')
	if (props.wrap && props.dir !== 'v') classes.push('is-wrap')

	return classes
})
</script>
